import { api } from './client';

export interface AuthUser {
  userId: string;
  email: string;
  role: 'dev' | 'manager' | 'exec';
  teamId: string;
  groupId: string;
}

export interface AuthResponse {
  token: string;
  user: AuthUser;
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  const r = await api.post<AuthResponse>('/auth/login', { email, password });
  return r.data;
}

export async function register(payload: {
  email: string;
  password: string;
  confirmPassword: string;
  inviteCode: string;
  roleHint: 'dev' | 'manager';
}): Promise<AuthResponse> {
  const r = await api.post<AuthResponse>('/auth/register', payload);
  return r.data;
}
